import { createAction, createActionGroup, props } from '@ngrx/store';

// Models
import { Session, User } from '@core/models/session.interface';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';


export const SessionActions = createActionGroup({
  source: 'Session',
  events: {
    'inject user': props<{ user: User }>(),
    // 'inject token': props<{ token: Token }>()
  },
});

export const SessionEffectsActions = createActionGroup({
  source: 'API Session',
  events: {
    'log in': props<any>(),
    'log out': props<any>(),
    'eject user': props<any>(),
    'inject error': props<{ error: any }>(),
  },
});

//
